import * as Sentry from '@sentry/nextjs';

type LoggerOptions = {
    tags?: Record<string, string>;
    extra?: Record<string, unknown>;
    level?: 'error' | 'warning' | 'info';
};

export abstract class Logger {
    static error(rawError: unknown, options?: LoggerOptions): void {
        Sentry.withScope((scope) => {
            if (options?.tags) {
                Object.entries(options.tags).forEach(([k, v]) => scope.setTag(k, v));
            }
            if (options?.extra) {
                Object.entries(options.extra).forEach(([k, v]) => scope.setExtra(k, v));
            }
            scope.setLevel(options?.level ?? 'error');
            Sentry.captureException(rawError instanceof Error ? rawError : new Error(String(rawError)));
        });
    }

    // Évènement de funnel / instrumentation produit — posé en breadcrumb Sentry (pas un appel
    // Sentry direct dans la feature, conformément au pattern Logger). Non bloquant, fire-and-forget.
    static event(name: string, data?: Record<string, unknown>): void {
        Sentry.addBreadcrumb({ category: 'funnel', message: name, level: 'info', data });
    }

    static setUserContext(ctx: { profileId?: string; sessionId?: string; role?: string }): void {
        Sentry.setUser({ id: ctx.profileId });
        if (ctx.sessionId) Sentry.setTag('sessionId', ctx.sessionId);
        if (ctx.role) Sentry.setTag('role', ctx.role);
    }
}
